document.addEventListener("DOMContentLoaded", function () {
    const wishlistButtons = document.querySelectorAll(".wishlist-button");
    const wishlistCount = document.querySelector("#wishlist-count");
    const wishlistContainer = document.querySelector("#wishlist-items");

    function getWishlist() {
        return JSON.parse(localStorage.getItem("wishlist")) || [];
    }

    function saveWishlist(wishlist) {
        localStorage.setItem("wishlist", JSON.stringify(wishlist));
    }

    function updateWishlistCount() {
        const wishlist = getWishlist();
        if (wishlistCount) {
            wishlistCount.textContent = wishlist.length;
        }
    }

    wishlistButtons.forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();
            const productId = this.dataset.productId;
            let wishlist = getWishlist();

            if (wishlist.includes(productId)) {
                wishlist = wishlist.filter(id => id !== productId);
                this.classList.remove("added");
            } else {
                wishlist.push(productId);
                this.classList.add("added");
            }

            saveWishlist(wishlist);
            updateWishlistCount();
        });
    });

    if (wishlistContainer) {
        let wishlist = getWishlist();
        if (wishlist.length === 0) {
            wishlistContainer.innerHTML = "<p>Deine Wunschliste ist leer.</p>";
        } else {
            wishlist.forEach(productId => {
                fetch(`/products/${productId}.json`)
                .then(response => response.json())
                .then(data => {
                    let product = data.product;
                    let productHtml = `
                        <div class="wishlist-item">
                            <img src="${product.images[0].src}" alt="${product.title}">
                            <h3><a href="${product.url}">${product.title}</a></h3>
                            <p>${product.variants[0].price / 100}€</p>
                            <button class="remove-wishlist" data-product-id="${product.id}">✖ Entfernen</button>
                        </div>
                    `;
                    wishlistContainer.innerHTML += productHtml;
                });
            });
        }

        document.addEventListener("click", function (event) {
            if (event.target.classList.contains("remove-wishlist")) {
                let productId = event.target.dataset.productId;
                let wishlist = getWishlist();
                wishlist = wishlist.filter(id => id !== productId);
                saveWishlist(wishlist);
                location.reload();
            }
        });
    }

    updateWishlistCount();
});
document.addEventListener("DOMContentLoaded", function () {
    const wishlistContainer = document.getElementById("wishlist-items"); // Stelle sicher, dass dieser Container existiert!
    const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];

    if (wishlistContainer) {
        if (wishlistData.length === 0) {
            wishlistContainer.innerHTML = "<p>Deine Wunschliste ist leer.</p>";
        } else {
            wishlistContainer.innerHTML = wishlistData
                .map(
                    (product) => `
                <div class="wishlist-item">
                    <img src="${product.image}" alt="${product.title}" class="wishlist-img"/>
                    <div class="wishlist-info">
                        <h3>${product.title}</h3>
                        <p>${product.price}</p>
                        <a href="${product.url}" class="btn btn--primary">Zum Produkt</a>
                        <button class="remove-wishlist-item" data-id="${product.id}">🗑 Entfernen</button>
                    </div>
                </div>
            `
                )
                .join("");
        }
    }

    // Event-Listener für „Entfernen“ Buttons
    document.querySelectorAll(".remove-wishlist-item").forEach((button) => {
        button.addEventListener("click", function () {
            const productId = this.getAttribute("data-id");
            const updatedWishlist = wishlistData.filter((item) => item.id !== productId);
            localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
            location.reload(); // Seite neu laden, um die Änderung zu sehen
        });
    });
});